export default __webpack_public_path__ + "static/media/talkTo_ImgDefault.e31c8b9a.svg";